import React, {useState,useEffect} from "react";
import axios from 'axios';
import jwt_decode from "jwt-decode";
import { toast } from 'react-toastify';
import {useNavigate, Link, useParams} from "react-router-dom";

const EditUser = () => {
    const {idUser} = useParams();
    const [spvUsers, setSpvUsers] = useState([]);
    const [idSpvUser, setIdSpvUser] = useState("");
    const [username, setUsername] = useState("");
    const [namaLengkap, setNamaLengkap] = useState("");
    const [email, setEmail] = useState("");
    const [role, setRole] = useState(null);
    const [cabang, setCabang] = useState("");
    const [password, setPassword] = useState("");
    const [confPassword, setConfPassword] = useState("");
    const [token, setToken] = useState("");
    const [expire, setExpire] = useState("");
    const [msg, setMsg] = useState("");
    const navigate = useNavigate();

    useEffect(() => {
        refreshToken();
        getUserById();
        getSpvUsers();
    },[]);

    const refreshToken = async() => {
        try {
              const response = await axios.get(`${process.env.REACT_APP_MASTER_URL}/token`);
              setToken(response.data.accessToken);
              const decoded = jwt_decode(response.data.accessToken);
              setExpire(decoded.exp);
              if (decoded.role === "admin") {
                navigate("/")
                }
              
        } catch (error) {
            if(error.response){
              navigate("/login");
            }
        }
      }
      
      const axiosJWT = axios.create();
      
      axiosJWT.interceptors.request.use(async(config) => {
          const curretDate = new Date();
          if(expire * 1000 < curretDate.getTime()){
              const response = await axios.get(`${process.env.REACT_APP_MASTER_URL}/token`);
              config.headers.Authorization = `Bearer ${response.data.accessToken}`;
              setToken(response.data.accessToken);
              const decoded = jwt_decode(response.data.accessToken);
              setExpire(decoded.exp);
          }
          return config;
      }, (error) => {
          return Promise.reject(error);
      });
      
      const getUserById = async () => {
        const response = await axiosJWT.get(`${process.env.REACT_APP_MASTER_URL}/users/${idUser}`,{
            headers:{
                Authorization:`Bearer ${token}`
            }
        });
            setUsername(response.data.username);
            setEmail(response.data.email);
            setNamaLengkap(response.data.namaLengkap);
            setRole(response.data.role);
            setCabang(response.data.cabang);
            setIdSpvUser(response.data.idSpvUser);

        }
        
        const getSpvUsers = async () => {
        const response = await axiosJWT.get(`${process.env.REACT_APP_MASTER_URL}/spvusers`,{
            headers:{
                Authorization:`Bearer ${token}`
            }
        });
        setSpvUsers(response.data);
        }

    const editUserRegister = async (e) =>{
        e.preventDefault();
        let formData = new FormData();
            formData.append('username',username);
            formData.append('namaLengkap',namaLengkap);
            formData.append('email',email);
            formData.append('role',role);
            formData.append('cabang',cabang);
            formData.append('idSpvUser',idSpvUser);
            formData.append('password',password);
            formData.append('confPassword',confPassword);
        try {
            await axios.patch(`${process.env.REACT_APP_MASTER_URL}/users/update/${idUser}`,formData,{
                headers:{ 
                    'Content-Type':'multipart/form-data'
                }
            });
            navigate("/users")
        } catch (error) {
            if(error.response){
               toast.warning(error.response.data.msg);
            }   
        }  
    }

  return (
    <section className="hero has-background-grey-light is-fullheight is-fullwidth">
      <div className="hero-body">
        <div className="container">
            <div className="columns is-centered">
                <div className="column is-4-desktop">
                    <form className="box" onSubmit={editUserRegister}>
                        <p style={{color:"red"}} className="has-text-centered">{msg}</p>
                        <div className="filed mt-5">
                                <label className="label">Nama Lengkap</label>
                                <div className="controls">
                                    <input required type="text" className="input" value={namaLengkap} onChange={(e)=> setNamaLengkap(e.target.value)} placeholder="Username"/>
                                </div>
                            </div>
                        <div className="filed mt-5">
                            <label className="label">Username</label>
                            <div className="controls">
                                <input required type="text" className="input" value={username} onChange={(e)=> setUsername(e.target.value)} placeholder="Username"/>
                            </div>
                        </div>
                        <div className="filed mt-5">
                            <label className="label">Email</label>
                            <div className="controls">
                                <input required type="text" className="input" value={email} onChange={(e)=> setEmail(e.target.value)} placeholder="Email"/>
                            </div>
                        </div>
                        <div className='field'>
                            <label className='label'>Role</label>
                            <div className='control'>
                                <div className='select is-fullwidth'>
                                    <select required value={role} onChange={(e)=> setRole(e.target.value)}>
                                        <option value=''>--Silahkan Pilih--</option>
                                        <option value="superAdmin">Super Admin</option>
                                        <option value="admin">Admin</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div className='field'>
                            <label className='label'>Cabang</label>
                            <div className='control'>
                                <div className='select is-fullwidth'>
                                    <select required value={cabang} onChange={(e)=> setCabang(e.target.value)}>
                                        <option value=''>--Silahkan Pilih--</option>
                                        <option value="Wlingi">Wlingi</option>
                                        <option value="Kepanjen">Kepanjen</option>
                                        <option value="Brondong">Brondong</option>
                                        <option value="Gresik">Gresik</option>
                                        <option value="Tuban">Tuban</option>
                                        <option value="Ngadiluwih">Ngadiluwih</option>
                                        <option value="Ngunut">Ngunut</option>
                                        <option value="Situbondo">Situbondo</option>
                                        <option value="Genteng">Genteng</option>
                                        <option value="Rambipuji">Rambipuji</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div className="field">
                            <label className="label">Supervisor</label>
                            <div className="control">
                                <div className="select is-fullwidth">
                                <select
                                    required
                                    value={idSpvUser}
                                    onChange={(e) => setIdSpvUser(e.target.value)}
                                >
                                    <option value="">-- Silahkan Pilih Supervisor --</option>

                                    {spvUsers.map((spv) => (
                                    <option key={spv.idSpvUser} value={spv.idSpvUser}>
                                        {spv.namaSpv}
                                    </option>
                                    ))}
                                </select>
                                </div>
                            </div>
                            </div>
                        <div className="field mt-5">
                                <label className="label">Password Baru</label>
                                <div className="controls">
                                    <input
                                    type="password"
                                    className={`input ${password.length > 0 && password.length < 6 ? "is-danger" : ""}`}
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    placeholder="*****"
                                    />
                                </div>

                                {password.length > 0 && password.length < 6 && (
                                    <p className="help is-danger">
                                    Password minimal 6 karakter
                                    </p>
                                )}
                        </div>
                        <div className="field mt-5">
                                <label className="label">Konfirmasi Password</label>
                                <div className="controls">
                                    <input
                                    type="password"
                                    className={`input ${confPassword.length > 0 && confPassword.length < 6 ? "is-danger" : ""}`}
                                    value={confPassword}
                                    onChange={(e) => setConfPassword(e.target.value)}
                                    placeholder="*****"
                                    />
                                </div>

                                {confPassword.length > 0 && confPassword.length < 6 && (
                                    <p className="help is-danger">
                                    Password minimal 6 karakter
                                    </p>
                                )}
                        </div>
                        <div className="filed mt-5">
                            <button className="button is-link is-fullwidth">Update</button>
                        </div>
                    </form>
                </div>

            </div>
          
        </div>
      </div>
    </section>
  )
}

export default EditUser